export enum ROUTE_NAMES {
    CONTAINER_TRACKING = '/container-tracking',
    ORDERS = '/orders',
    DISPATCH = '/dispatch',
    CONTACTS = '/contacts',
    DIRECTORY = '/directory',
    COMPANY = '/company',
    DASHBOARD = '/dashboard',
    // TODO: add rest
}

export function getCityDirectoryPage(cityName: string): string {
    return `${ROUTE_NAMES.DIRECTORY}/${cityName}`;
}

export function getCompanyDirectoryInfoPage(companyId: number): string {
    return `${ROUTE_NAMES.COMPANY}/${companyId}`;
}
